import React from 'react';

import PropTypes from 'prop-types';

import { PromoIcon } from 'components/no-auth/common/promo-icon/PromoIcon';
import { PromoSpinnerCircle } from 'components/no-auth/common/PromoSpinner/PromoSpinnerCircle';

import clsx from 'clsx';

import styles from './PromoButton.module.css';

export const PromoButton = React.forwardRef(({ type = 'button', variant = 'primary', isInverted, disabled, caption, iconName, withSpinner, ...props }, ref) => {
    const classNames = clsx(styles.button, styles[variant], isInverted && styles.inverted, disabled && styles.disabled);

    const content = (
        <>
            {caption}
            {iconName && (
                <span className={styles.iconContainer}>
                    <PromoIcon name={iconName} />
                </span>
            )}
            {withSpinner && <PromoSpinnerCircle isWhite size="16px" />}
        </>
    );

    if (type === 'link') {
        return (
            <a ref={ref} className={classNames} {...props}>
                {content}
            </a>
        );
    } else if (type === 'pseudo') {
        return (
            <span className={classNames} {...props}>
                {content}
            </span>
        );
    }
    return (
        <button ref={ref} className={classNames} disabled={disabled} {...props}>
            {content}
        </button>
    );
});

PromoButton.propTypes = {
    type: PropTypes.oneOf(['link', 'pseudo', 'button']),
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    isInverted: PropTypes.bool,
    disabled: PropTypes.bool,
    href: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
    tabIndex: PropTypes.string,
    caption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    withSpinner: PropTypes.bool,
};
